/* src/components/MobileBlocked.jsx */
import Logo from "../assets/logo.png"; // ⬅️ SVG 또는 PNG 경로로 교체하세요

export default function MobileBlocked() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-50 to-white">
      {/* ─── 브랜드 ロ고 ─── */}
      <img
        src={Logo}
        alt="Elva Logo"
        className="w-24 h-24 mb-8 drop-shadow-md select-none"
        draggable={false}
      />

      {/* ─── 안내 카드 ─── */}
      <div className="w-[90%] max-w-sm rounded-3xl bg-white/80 backdrop-blur-md shadow-xl p-6 text-center space-y-5">
        <h1 className="text-xl font-semibold text-gray-800 leading-relaxed">
          현재&nbsp;Elva는
          <br className="sm:hidden" />
          <span className="inline-block text-indigo-600 font-bold">
            &nbsp;기업용&nbsp;프로토콜&nbsp;제약
          </span>
          으로 인해
          <br className="sm:hidden" /> 모바일 접근이 제한됩니다.
        </h1>

        <p className="text-gray-600">
          데스크톱 환경에서
          <br /> 접속해 주세요.
        </p>

        <div className="flex justify-center">
          <svg
            className="w-10 h-10 text-indigo-500 animate-bounce"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4v16m8-8H4"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
